var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9254 13.4282L10.3396 12.8425C9.55857 12.0614 9.55857 10.7951 10.3396 10.014L14.8445 5.50913C15.6256 4.72808 16.8919 4.72808 17.6729 5.50913L18.8445 6.68069C19.6256 7.46174 19.6256 8.72807 18.8445 9.50912L17.2587 11.0949M13.5921 10.7616L14.1778 11.3474C14.9589 12.1284 14.9589 13.3948 14.1778 14.1758L9.67294 18.6807C8.89189 19.4617 7.62556 19.4617 6.84451 18.6807L5.67295 17.5091C4.8919 16.7281 4.8919 15.4618 5.67294 14.6807L7.25873 13.0949",
    stroke: "#2D3138",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinking);
export default __webpack_public_path__ + "static/media/linking.58e28ab803231dc02171b4fa995a7b75.svg";
export { ForwardRef as ReactComponent };